module.exports = __webpack_public_path__ + "media/site/images/products/avisboard-flat-screen2@2x-52a8ea27c5c786883fab06199dcf623a.png";